import React, { Component } from "react";
import { PrimaryButton } from "../../components/BasicForm";
import { CertCheckbox } from "../../components/CertCheckbox";
import { VisitorInfoCard } from "../../components/VisitorInfoCard";
import { SelectedMinorInfoCard } from "../../components/SelectedMinorInfoCard";
import { SelectedMinorReview } from "../../components/SelectedMinorReview";
import { OffenderReviewCard } from "../../components/OffenderReviewCard";
import { formatFields } from "../../utils/formatFields";
import { relationships } from "../../utils/relationshipList";

class ApplicationReview extends Component {
  state = {
    heading: "Review Your Application",
    showProgressBar: true,
    pageId: "application-review",
    applicantFieldsErr: false,
    validMinors: {},
    minorFieldsErr: false
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
    this.props.fields.finalAuthorization.value = false;
    this.validateFatalFields(Object.keys(this.props.fatalApplicantFields));
    this.validateMinorFatalFields(this.props.fields.selectedMinors);
    this.validateNonFatalFields(this.props.nonFatalApplicantFields);
    // this.validateNonFatalMinorFields(this.props.fields.selectedMinors);
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  validateFatalFields(fields) {
    this.props.validateStep(fields);
  }
  validateMinorFatalFields(minors) {
    const fatalFields = [
      "gangAssociation",
      "victimOfOffender",
      "courtSupervision"
    ];
    Object.keys(minors).map(minorId => {
      this.props.setCurrentMinor(minorId);
      this.props.validateMinorStep(fatalFields);
      return minorId;
    });
  }
  validateNonFatalFields = applicantFields => {
    const isApplicantFieldsErr = this.props.validateStep(applicantFields);
    if (isApplicantFieldsErr) {
      this.setState({
        applicantFieldsErr: true
      });
    }
  };
  // validateNonFatalMinorFields = (minors) => {
  //   let isMinorFieldsErr = false;
  //   let validMinors = {};
  //   const self = this;
  //   Object.keys(minors).map((minorId) => {
  //     self.props.setCurrentMinor(minorId);
  //     const minorErr = self.props.validateMinorStep(Object.keys(minors[minorId].fields));
  //     validMinors[minorId] = minorErr;
  //     if(minorErr) {
  //       isMinorFieldsErr = true;
  //     };
  //   });

  //   this.setState({
  //     validMinors: validMinors,
  //     minorFieldsErr: isMinorFieldsErr,
  //   });
  // }
  handleOffenderEdit = minorId => {
    this.props.setCurrentMinor(minorId);
    this.props.history.push("/minor-visit-selection");
  };
  handleMinorEdit = minorId => {
    this.props.setCurrentMinor(minorId);
    this.props.history.push("/minor-information");
  };
  handleEditClick = options => {
    if (options.minorId) {
      this.props.setCurrentMinor(options.minorId);
    }
    this.props.history.push(options.url);
  };
  handleSubmitApplication = fields => {
    const isErr = this.props.validateStep(fields);

    if (
      !isErr &&
      !this.state.applicantFieldsErr &&
      !this.state.minorFieldsErr
    ) {
      this.props.handleSubmitApplication();
    } else if (isErr) {
      this.scrollToError();
    } else {
      this.scrollToApplicant();
    }
  };
  scrollToError = () => {
    const fields = this.props.fields;
    let errFields = [];
    Object.keys(fields).map(fieldName => {
      if (fields[fieldName].className === "input-err") {
        errFields.push(fieldName);
      }
      return fieldName;
    });
    const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
    firstErr.scrollIntoView();
  };
  scrollToApplicant = () => {
    const applicantSection = document.querySelectorAll(".section-error")[0];
    applicantSection.scrollIntoView();
  };
  render() {
    const fields = this.props.fields;
    const visitorFields = fields.visitorFields;
    const visitorQuestFields = formatFields(visitorFields);
    const selectedOffenders = fields.selectedOffenders;
    const selectedMinors = fields.selectedMinors;
    console.log('field', fields);
    return (
      <div className="col-15">
        <p>
          Please review your answers before submitting the application.
        </p>
        <div className="review-list-header">
          <h3>Visitor Questionnaire</h3>
          <PrimaryButton
            className="link-style"
            label="Edit"
            handleClick={this.handleEditClick}
            options={{
              url: "visitor-questionnaire"
            }}
          />
          <p className="description">
            Your responses to the Visitor Questionnaire are listed below.
          </p>
        </div>
        <ul className="visitation-result-cards">
          {Object.keys(visitorQuestFields).map(key => {
            return (
              <li key={key} className="result-data">
                <p>{visitorQuestFields[key]}</p>
              </li>
            );
          })}
        </ul>
        <div id="visitation-info" className="review-list-header">
          <h3>Types of Visitation</h3>
          <PrimaryButton
            className="link-style"
            label="Edit"
            handleClick={this.handleEditClick}
            options={{ url: "visitor-questionnaire" }}
          />
          <p className="description">
            Your response to the Types of Visitation question is listed below.
          </p>
          <ul className="visitation-result-cards">
            <li className="result-data"><p>You are applying for {visitorFields.applicantVisitationType.value}.</p></li>
          </ul>
        </div>
        <div className="review-list-header">
          <h3>Inmate Information</h3>
          <PrimaryButton
            className="link-style"
            label="Edit"
            handleClick={this.handleEditClick}
            options={{ url: "selected-offenders" }}
          />
          <p className="description">
            Below are the inmates you have selected to visit.
          </p>
        </div>
        <ul className="visitation-result-cards">
          {Object.keys(selectedOffenders).map(id => {
            const offender = selectedOffenders[id];
            return (
              <OffenderReviewCard
                key={id}
                FullName={offender.FullName}
                Age={offender.Age}
                Race={offender.Race}
                Gender={offender.Gender}
                Alias={offender.Alias}
                OffenderId={offender.OffenderId}
                LocationName={offender.LocationName}
                ProjectedReleaseDate={offender.ProjectedReleaseDate}
                RelationshipToVisitor={
                  relationships[offender.RelationshipToVisitor.value]
                }
              />
            );
          })}
        </ul>
        <div id="visitor-info" className="review-list-header">
          {this.state.applicantFieldsErr ? (
            <p className="section-error">
              There are one or more errors in your application. Please click the
              "Edit" button to fix errors in this section. Otherwise, you will
              not be able to submit your application
            </p>
          ) : (
            false
          )}
          <h3>Your Information</h3>
          <PrimaryButton
            className="link-style"
            label="Edit"
            handleClick={this.handleEditClick}
            options={{ url: "applicant-information" }}
          />
          <p className="description">
            Your responses to the Your Information section are listed below. 
          </p>
        </div>
        <VisitorInfoCard
          firstName={visitorFields.firstName.value}
          middleName={visitorFields.middleName.value}
          lastName={visitorFields.lastName.value}
          otherName={visitorFields.otherName.value}
          applicantHair={this.props.getOptionName(
            visitorFields.applicantHair,
            visitorFields.applicantHair.value
          )}
          applicantEyes={this.props.getOptionName(
            visitorFields.applicantEyes,
            visitorFields.applicantEyes.value
          )}
          applicantRace={this.props.getOptionName(
            visitorFields.applicantRace,
            visitorFields.applicantRace.value
          )}
          applicantSex={this.props.getOptionName(
            visitorFields.applicantSex,
            visitorFields.applicantSex.value
          )}
          applicantHeightFt={visitorFields.applicantHeightFt.value}
          applicantHeightIn={visitorFields.applicantHeightIn.value}
          applicantWeight={visitorFields.applicantWeight.value}
          applicantIdType={this.props.getOptionName(
            visitorFields.applicantIdType,
            visitorFields.applicantIdType.value
          )}
          applicantIdNumber={visitorFields.applicantIdNumber.value}
          applicantSsn={visitorFields.applicantSsn.value}
        />
        {Object.keys(selectedMinors).length > 0 ? (
          Object.keys(selectedMinors).map(minorId => {
            const minor = selectedMinors[minorId];
            const offenders = minor.selectedOffenders;
            const minorFields = minor.fields;
            const minorErr = this.state.validMinors[minorId];
            return (
              <div key={minorId}>
                <div id="minor-info" className="review-list-header">
                  {minorErr ? (
                    <p className="section-error">
                      There are one or more errors in your application. Please
                      click the "Edit" button to fix errors in this section.
                      Otherwise, you will not be able to submit your application
                    </p>
                  ) : (
                    false
                  )}
                  <h3>Minor's Information</h3>
                  <PrimaryButton
                    className="link-style"
                    label="Edit"
                    handleClick={this.handleEditClick}
                    options={{
                      url: "minor-questionnaire",
                      minorId: minorId
                    }}
                  />
                  <p className="description">
                    Your responses to the Minor Information section are listed below. 
                  </p>
                  <SelectedMinorInfoCard
                    firstName={minorFields.firstName.value}
                    middleName={minorFields.middleName.value}
                    lastName={minorFields.lastName.value}
                    dob={minorFields.DOB.value}
                    ssn={minorFields.ssn.value}
                    pob={minorFields.placeOfBirth.value}
                    race={this.props.getOptionName(
                      minorFields.race,
                      minorFields.race.value
                    )}
                    sex={this.props.getOptionName(
                      minorFields.sex,
                      minorFields.sex.value
                    )}
                  />
                </div>
                <SelectedMinorReview
                  minorId={minorId}
                  offenders={offenders}
                  minorFields={minorFields}
                  handleEditClick={this.handleEditClick}
                />
              </div>
            );
          })
        ) : (
          <div className="review-list-header">
            <h3>Minor's Information</h3>
            <div>
              <p id="no-minor-added" className="body-bold">
                You have not added a minor to this application.
              </p>
              <PrimaryButton
                className="link-style"
                label="Add a Minor"
                handleClick={this.handleEditClick}
                options={{
                  url: "add-minor"
                }}
              />
            </div>
          </div>
        )}
        <form
          className="visitation-form clear-fix"
          id="application-review-confirm"
        >
          <CertCheckbox
            name="finalAuthorization"
            value={fields.finalAuthorization.value}
            label={fields.finalAuthorization.label}
            required="true"
            onChange={this.props.handleInputChange}
            errMessage={fields.finalAuthorization.errMessage}
            labelClass="body-bold"
          />
          <p id="submission-clause" className="body-bold">
            By clicking “Submit Application,” I certify the information above is
            true and correct. I understand that providing false information on
            the form is grounds for denying visitation privileges.
          </p>
          <PrimaryButton
            className="primary-button"
            label="Submit Application"
            handleClick={this.handleSubmitApplication}
            options={["finalAuthorization"]}
          />
        </form>
      </div>
    );
  }
}

export default ApplicationReview;



// WEBPACK FOOTER //
// ./src/pages/ApplicationReview/ApplicationReview.js